import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    subjectName: '',
    level: '',
    subjectType: '',
    loading: false,
}

const NewSubject = () => {

    const [currentNotify, setNotify] = useState(null);
    const {getClassLevels, classLevels, getSubjectTypes, getSubjectCategories, getSubjects, subjectCategories, subjectTypes} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getClassLevels();
        getSubjectTypes();
        getSubjectCategories();
    }, [])

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.subjectName.length === 0 || !state.level.value || !state.subjectCategory.value || !state.subjectType.value){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.createSubject(
            state.subjectName, 
            state.level.value,
            state.subjectCategory.value,
            state.subjectType.value
        );
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'subjectName', value: ''});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getSubjects(true);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


      const RenderClassLevel = () => {
        const options = [];
        if (Array.isArray(classLevels) && classLevels.length > 0) {
            classLevels.map((item, key) =>
                options.push({ label: item.level, value: item.level_id })
            );
        }

        return (
            <TextInput
                label="Class Level"
                type="select"
                leftIcon={true}
                placeholder={state.level?.label || 'Select class level....'}
                options={options}
                onChange={(item) => dispatch({ type: 'level', value: item })}
                leftComponent={<i className="fa fa-bookmark link" onClick={getClassLevels}></i>}
                loading={!classLevels}
                wrap
            />
        );
    };

    const RenderSubjectType = () => {
        const options = [];
        if (Array.isArray(subjectTypes) && subjectTypes.length > 0) {
            subjectTypes.map((item, key) =>
                options.push({ label: item.type_name, value: item.type_id })
            );
        }

        return (
            <TextInput
                label="Subject Type"
                type="select"
                leftIcon={true}
                placeholder={state.subjectType?.label || 'Select subject type....'}
                options={options}
                onChange={(item) => dispatch({ type: 'subjectType', value: item })}
                leftComponent={<i className="fa fa-diamond link" onClick={()=>getSubjectTypes(true)}></i>}
                loading={!subjectTypes}
                wrap
            />
        );
    };


    const RenderSubjectCategory = () => {
        const options = [];
        if (Array.isArray(subjectCategories) && subjectCategories.length > 0) {
            subjectCategories.map((item, key) =>
                options.push({ label: item.category, value: item.category_id })
            );
        }

        return (
            <TextInput
                label="Subject Category"
                type="select"
                leftIcon={true}
                placeholder={state.subjectCategory?.label || 'Select subject category....'}
                options={options}
                onChange={(item) => dispatch({ type: 'subjectCategory', value: item })}
                leftComponent={<i className="fa fa-tree link" onClick={getSubjectCategories}></i>}
                loading={!subjectCategories}
                wrap
            />
        );
    }   


  

    return (
        <div className="card-body">

            <CallOut 
                title="Subject"
                description="Create a new subject for the school. Make sure to select the correct class level."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Subject Name"
                            placeholder="Subject Name"
                            leftIcon="fa fa-book"
                            value={state.subjectName}
                            onChange={e => dispatch({type: 'subjectName', value: e.target.value})}
                            required
                            wrap
                            />

                        {RenderClassLevel()}

                        {RenderSubjectCategory()}

                        {RenderSubjectType()}
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Subject</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewSubject;